import {
  ManagementFunnel,
  ManagementSummary,
  ProcessFunnelStage,
} from "../models/Management";
import api from "./api";

// Mesmo conjunto de filtros da tela /processes (ProcessQuery no backend).
// includeClosed só é relevante pro funil (GetSummaryAsync sempre olha ativos+encerrados).
export interface ManagementFilters {
  type?: number;
  companyId?: string;
  includeClosed?: boolean;
  isUrgent?: boolean;
  multiStatus?: string;
  teamId?: string;
  importMode?: string;
  dateType?: string;
  initialDate?: string;
  finalDate?: string;
  clientRef?: string;
  ncm?: string;
  departurePort?: string;
  dischargePort?: string;
  cvfRef?: string;
  countryOfOrigin?: string;
  exporter?: string;
  responsible?: string;
  product?: string;
  insurance?: string;
}

// getSummary/getFunnel propagam erro (em vez de engolir e devolver vazio) — um board vazio
// e um board que falhou parecem idênticos pro usuário se a gente não deixar o erro subir.
export const getSummary = async (
  filters: ManagementFilters
): Promise<ManagementSummary> => {
  const response = await api.get(`/api/management/summary`, {
    params: filters,
  });
  return response.data;
};

export const getFunnel = async (
  filters: ManagementFilters
): Promise<ManagementFunnel> => {
  const response = await api.get(`/api/management/funnel`, {
    params: filters,
  });
  return response.data ?? { stages: [] };
};

// CRUD de etapas também propaga erro — o chamador (FunnelStageManager) decide como avisar o usuário.
export const getStages = async (): Promise<ProcessFunnelStage[]> => {
  const response = await api.get(`/api/management/stages`);
  return response.data ?? [];
};

export const saveStage = async (stage: ProcessFunnelStage) => {
  const response = await api.post(`/api/management/stages`, stage);
  return response.data;
};

export const updateStage = async (stage: ProcessFunnelStage) => {
  const response = await api.put(`/api/management/stages/${stage.id}`, stage);
  return response.data;
};

export const deleteStage = async (id: string) => {
  const response = await api.delete(`/api/management/stages/${id}`);
  return response.data;
};

export const reorderStages = async (orderedIds: string[]) => {
  const response = await api.put(`/api/management/stages/reorder`, orderedIds);
  return response.data;
};

// Move de card no funil = alterar Process.Status via o endpoint genérico já existente.
// Propaga erro — quem chama precisa saber se a movimentação falhou pra não confirmar com um toast falso.
export const updateProcessStatus = async (processId: string, status: string) => {
  const response = await api.patch(`/api/Process/UpdateField`, {
    processId,
    fieldName: "Status",
    value: status,
  });
  return response.data;
};
